export const PROFILE_GET_PROFILE = 'PROFILE_GET_PROFILE';
export const PROFILE_LOADING = 'PROFILE_LOADING';
export const PROFILE_NOT_FOUND = 'PROFILE_NOT_FOUND';
export const PROFILE_CLEAR_CURRENT_PROFILE = 'PROFILE_CLEAR_CURRENT_PROFILE';
export const PROFILE_GET_PROFILES = 'PROFILE_GET_PROFILES';